<template>
  <div class="popup-toast">{{ text }}</div>
</template>

<script>
export default {
  name: "Toast",
  props: {
    appender: Object,
    text: {
      type: String,
    },
    duration: {
      type: Number,
      default: 2800,
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.appender) {
        this.appender.close();
      }
    }, this.duration);
  },
  data() {
    return {};
  },
  methods: {
    open() {
      this.scale = true;
      this.$nextTick(() => (this.show = true));
    },
    close(callback) {
      this.scale = false;
      this.$nextTick(() => {
        this.show = false;
        setTimeout(() => {
          typeof callback === "function" && callback();
        }, 260);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
@include setThemeClass {
  .popup-toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 208px;
    min-width: 100px;
    padding: 0 20px;
    @include h5(getThemeVal(brandColorWhite));
    background-color: getThemeVal(maskColor);
    box-sizing: border-box;
    height: 48px;
    line-height: 48px;
    border-radius: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 2px;
    z-index: 100;
  }
}
</style>
